module.exports = __webpack_public_path__ + "static/img/21-红英小学(六里屯校区).0df361c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/21-红英小学(六里屯校区).png
// module id = 81ca
// module chunks = 0